import Moment from 'moment'

Moment.updateLocale('es', {
    months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
    monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sept_Oct_Nov_Dic'.split('_'),
    weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
    weekdaysShort: 'Dom_Lun_Mar_Mier_Jue_Vier_Sab'.split('_'),
    weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
});

const centralFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Mexico_City',
    timeZoneName: 'longOffset'
})

export default {
    hourShort,
    hourLarge,
    dateShort,
    dateLarge,
    dateTimeShort,
    dateTimeLarge,
    central,
    centralHourLarge,
    centralDateTimeLarge,
    isBefore,
    isBefore12,
    isAfter,
    isAfter12,
    weekday
}

function hourShort(value = new Date()) {
    return Moment(value).locale('es').format('hh:mm.a')
}

function hourLarge(value = new Date()) {
    return Moment(value).locale('es').format('hh:mm:ss a')
}

function dateShort(value = new Date()) {
    return Moment(value).locale('es').format('DD.MMM.YYYY')
}

function dateLarge(value = new Date()) {
    return Moment(value).locale('es').format('dddd DD MMMM YYYY')
}

function dateTimeShort(value = new Date()) {
    return Moment(value).locale('es').format('DD.MMM.YYYY hh:mm.a')
}

function dateTimeLarge(value = new Date()) {
    return Moment(value).locale('es').format('dddd DD MMMM YYYY hh:mm a')
}

// Misma fecha en hora centro de México, sin importar la zona del navegador.
function central(value = new Date()) {
    const date = new Date(value)
    const part = centralFormatter.formatToParts(date).find(item => item.type === 'timeZoneName')
    return Moment(date).utcOffset(part.value.replace('GMT', '')).locale('es')
}

function centralHourLarge(value = new Date()) {
    return central(value).format('hh:mm:ss a')
}

function centralDateTimeLarge(value = new Date()) {
    return central(value).format('dddd DD MMMM YYYY hh:mm a')
}

function isBefore(value, ref = new Date()) {
    return Moment(value).isBefore(ref)
}

function weekday(dateString, format) {
    return Moment(dateString, format).format('dddd')
}

function isAfter(value, ref = new Date()) {
    return Moment(value).isAfter(ref)
}

function isBefore12(value = new Date()) {

    if(!value)
        return false

    return Moment(value).isBefore(Moment().subtract(12, 'hours'))
}

function isAfter12(value = new Date()) {

    if(!value)
        return false

    return Moment(value).isAfter(Moment().subtract(12, 'hours'))
}